import React from 'react';
import { CustomDialog } from 'wix-ui-tpa/cssVars';
import { classes, st } from '../style/Dialog.st.css';

type DialogProps = {
  className: string;
  isMobileView: boolean;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  ariaLabeledBy?: string;
  ariaDescribedBy?: string;
};

const Dialog: React.FC<DialogProps> = ({
  isMobileView,
  className,
  isOpen,
  onClose,
  children,
  ariaLabeledBy,
  ariaDescribedBy,
}) => {
  return (
    <CustomDialog
      className={st(classes.root, { mobile: isMobileView }, className)}
      isOpen={isOpen}
      onClose={onClose}
      appendToBody={false}
      aria-describedby={ariaDescribedBy}
      aria-labelledby={ariaLabeledBy}
    >
      {children}
    </CustomDialog>
  );
};

export default Dialog;
